import React, { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { useLanguage } from "../i18n/LanguageContext";
import {
  ANALYTICS_CONSENT_EVENT,
  getAnalyticsConsent,
  updateAnalyticsConsent,
} from "../services/analyticsService";

const useConsent = () => {
  const [consent, setConsent] = useState(() => getAnalyticsConsent());
  useEffect(() => {
    const onChange = (event) => setConsent(event.detail || getAnalyticsConsent());
    window.addEventListener(ANALYTICS_CONSENT_EVENT, onChange);
    return () => window.removeEventListener(ANALYTICS_CONSENT_EVENT, onChange);
  }, []);
  return [consent, setConsent];
};

export function AnalyticsConsentBanner() {
  const { lang } = useLanguage();
  const [consent, setConsent] = useConsent();
  const [saving, setSaving] = useState(false);
  if (Capacitor.isNativePlatform() || consent) return null;

  const choose = async (next) => {
    setSaving(true);
    const saved = await updateAnalyticsConsent(next);
    setConsent(saved);
    setSaving(false);
  };

  return (
    <section className="analyticsConsentBanner" role="dialog" aria-modal="true" aria-labelledby="analytics-consent-title">
      <div>
        <strong id="analytics-consent-title">{lang === "en" ? "Help us improve Aile Yönetimi" : "Aile Yönetimi’ni geliştirmemize yardımcı olun"}</strong>
        <p>{lang === "en"
          ? "With your permission, we measure app usage and ad conversions. We never send family content, names, health, finance, message or precise location data. Ad personalization stays off."
          : "İzninizle uygulama kullanımını ve reklam dönüşümlerini ölçeriz. Aile içerikleri, adlar, sağlık, finans, mesaj veya hassas konum verileri asla gönderilmez. Reklam kişiselleştirme kapalı kalır."}</p>
      </div>
      <div className="analyticsConsentActions">
        <button type="button" disabled={saving} onClick={() => choose({ analytics: false, ads: false })}>
          {lang === "en" ? "Essential only" : "Yalnızca zorunlu"}
        </button>
        <button type="button" className="primary" disabled={saving} onClick={() => choose({ analytics: true, ads: true })}>
          {lang === "en" ? "Allow measurement" : "Ölçüme izin ver"}
        </button>
      </div>
    </section>
  );
}
